import React, { useMemo } from "react";

import { StoreState } from "common/store/types";
import { toUpperCaseFirst } from "common/utils/utility";
import { Transaction } from "common/store/transaction/types";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import {
  Paper,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  makeStyles,
  Box,
  Link,
} from "@material-ui/core";

const columns = [
  {
    id: "propertyName",
    label: "Property",
    format: (value: string) => {
      return `Sale #${value}`;
    },
  },
  {
    id: "txHash",
    label: "Tx Hash",
    format: (value: string) => (
      <Box
        whiteSpace="nowrap"
        overflow="hidden"
        textOverflow="ellipsis"
        textAlign="center"
        // maxWidth="400px"
      >
        <Link
          target="_blank"
          rel="noreferrer"
          style={{ color: "#4a4a4a" }}
          href={`https://ropsten.etherscan.io/tx/${value}`}
        >
          {value}
        </Link>
      </Box>
    ),
  },
  {
    id: "status",
    label: "Status",
    format: (value: string) => {
      return value;
    },
  },
];

interface Row {
  status: string;
  txHash: string;
  propertyName: string;
}

const useStyles = makeStyles({
  root: {
    width: "100%",
    borderRadius: "8px",
    boxShadow: "none",
    marginTop: "26px",
  },
  container: {
    maxHeight: 440,
    backgroundColor: "#fff",
  },
  header: {
    display: "none",
  },
  table: {
    backgroundColor: "#fff",
  },
});

export const TransactionTable = () => {
  const classes = useStyles();
  //const [page, setPage] = React.useState(0);
  //const [rowsPerPage, setRowsPerPage] = React.useState(10);

  //Hooks
  const { t } = useTranslation();
  const transactions = useSelector<StoreState, Transaction[]>(
    (state) => state.currentUser.transactions
  );

  const rows = useMemo(() => {
    return transactions.map((item: any) => {
      return {
        status: t(toUpperCaseFirst(item.status)),
        txHash: item.hash,
        propertyName: item.id,
      };
    });
  }, [transactions, t]);

  /*
  const handleChangePage = (event: any, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event: any) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  */

  return (
    <Paper className={classes.root}>
      <TableContainer className={classes.container}>
        <Table stickyHeader aria-label="sticky table" className={classes.table}>
          <TableHead className={classes.header}>
            <TableRow>
              {columns.map((column) => (
                <TableCell key={column.id}>{column.label}</TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows &&
              rows
                //.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row: any) => {
                  return (
                    <TableRow
                      hover
                      role="checkbox"
                      tabIndex={-1}
                      key={row.txHash}
                    >
                      {columns.map((column) => {
                        const value = row[column.id];
                        return (
                          <TableCell key={column.id}>
                            {value ? column.format(value.toString()) : value}
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  );
                })}
          </TableBody>
        </Table>
      </TableContainer>
      {/* <TablePagination
        rowsPerPageOptions={[10, 25, 100]}
        component="div"
        count={rows ? rows.length : 0}
        rowsPerPage={rowsPerPage}
        page={page}
        onChangePage={handleChangePage}
        onChangeRowsPerPage={handleChangeRowsPerPage}
      /> */}
    </Paper>
  );
};
